export let getTemplateUri = () => wp_theme_info.basePath;
export let getCheckoutUri = () => wp_theme_info.checkoutUri;